<template>
  <div class="main">
    <img class="frame" src="../../assets/image/frame.png" alt="" />
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="less">
.main {
  .frame {
    width: 100%;
    height: 100%;
  }
  width: 100%;
  height: 100%;
  box-shadow: 0px 3px 15px 0px rgba(68, 86, 103, 0.15);
}
</style>
